export default __webpack_public_path__ + "static/jbaynes-e0bc189c0c846bd2a89a5bcadb8a0b27.jpg";